var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.825 3.62a.498.498 0 0 0-.403-.114L9.49 5.216a.5.5 0 0 0-.422.495v9.795a2.774 2.774 0 0 0-.567-.355c-.739-.345-1.624-.373-2.43-.078-1.579.578-2.44 2.22-1.919 3.659a2.63 2.63 0 0 0 1.383 1.487c.4.186.843.28 1.293.28a3.31 3.31 0 0 0 1.137-.203c1.112-.407 1.865-1.341 2.033-2.361a.494.494 0 0 0 .07-.25v-8.34l9.931-1.553v5.979a2.774 2.774 0 0 0-.535-.33c-.74-.345-1.625-.374-2.43-.079-1.58.58-2.44 2.22-1.92 3.66a2.63 2.63 0 0 0 1.383 1.486c.4.186.843.28 1.294.28a3.31 3.31 0 0 0 1.136-.202c1.15-.421 1.916-1.406 2.048-2.467a.49.49 0 0 0 .024-.145V4a.5.5 0 0 0-.174-.38Z",
    clipRule: "evenodd"
  })));
};
export default SvgMusic;